import React, { Fragment } from 'react';
import { bool, func, object, string, array } from 'prop-types';

import { Tooltip, Input } from 'antd';
import { SvgIcon } from '../../svg-icon';
import {
  ContentDescription,
  ItemTitle,
  ItemColor,
  StyledItem,
  EditControls,
  EditColorAndTitleWrapper,
  ErrorMessage,
  SectionEditable,
  SectionEditableTop,
  SectionEditableDescription,
  ColorPickerStyled,
} from './styles';


export const EditableItem = ({
  tempData, errors, settingsType, isEdit, isNew, isDefault, handleClickEdit,
  handleCancelEdit, handleSelectNewColor, handleSelectNewTitle, handleSelectNewDescription,
  handleItemCreate, handleSaveChanges, handleItemRemove, editable,
}) => (
  <div>
    <StyledItem isEdit={isEdit}>
      { isEdit
        ? <Fragment>
          <SectionEditableTop>
            <EditColorAndTitleWrapper>
              <ColorPickerStyled
                color={tempData.color}
                onChange={handleSelectNewColor}
              />
              {isDefault
                ? <ItemTitle
                  title={tempData.title}
                  className={!editable && 'not-editable'}
                >
                  {tempData.title}
                </ItemTitle>
                : <SectionEditable
                  placeholder={isNew ? 'Title here' : `New ${settingsType}`}
                  autoFocus
                  defaultValue={tempData.title}
                  onChange={({ target: { value } }) => handleSelectNewTitle(value)}
                  onBlur={() => handleSelectNewTitle(tempData.title)}
                />
              }
            </EditColorAndTitleWrapper>
            <EditControls>
              {(!errors || !errors.length) && tempData.title && <SvgIcon
                type="check"
                color="#00D200"
                onClick={isNew ? handleItemCreate : handleSaveChanges}
              />}
              <SvgIcon type="cancel" onClick={handleCancelEdit} />
            </EditControls>
          </SectionEditableTop>
          <SectionEditableDescription>
            <Input.TextArea
              autosize
              autoFocus={isDefault}
              placeholder="Enter description here"
              defaultValue={tempData.description}
              onChange={({ target: { value } }) => handleSelectNewDescription(value)}
            />
          </SectionEditableDescription>
        </Fragment>
        : <Fragment>
          <ItemColor color={tempData.color} />
          {
            tempData.description
              ? <Tooltip title={<ContentDescription>{tempData.description}</ContentDescription>}>
                <ItemTitle
                  className={!editable && 'not-editable'}
                >
                  {tempData.title}
                </ItemTitle>
              </Tooltip>
              : <ItemTitle
                isNew={isNew}
                onClick={isNew ? handleClickEdit : null}
                className={!editable && 'not-editable'}
              >
                { isNew ? `New ${settingsType}` : tempData.title }
              </ItemTitle>
          }
          { editable &&
          <EditControls>
            { isNew
              ? <SvgIcon type="plus" onClick={handleClickEdit} />
              : !isDefault
                && <Fragment>
                  <SvgIcon type="pencil" onClick={handleClickEdit} />
                  <SvgIcon type="trash" onClick={handleItemRemove} />
                </Fragment>
                || <SvgIcon type="pencil" onClick={handleClickEdit} />
            }
          </EditControls> }
        </Fragment>
      }
    </StyledItem>
    {errors && errors.length
      ? errors.map((item, index) =>
        // eslint-disable-next-line react/no-array-index-key
        <ErrorMessage key={`error-${index}`}>{item}</ErrorMessage>)
      : ''}
  </div>
);

EditableItem.propTypes = {
  tempData: object.isRequired,
  settingsType: string.isRequired,
  isNew: bool.isRequired,
  isDefault: bool.isRequired,
  isEdit: bool.isRequired,
  handleClickEdit: func.isRequired,
  handleCancelEdit: func.isRequired,
  handleSelectNewColor: func.isRequired,
  handleSelectNewTitle: func.isRequired,
  handleSelectNewDescription: func.isRequired,
  handleSaveChanges: func.isRequired,
  handleItemCreate: func.isRequired,
  handleItemRemove: func.isRequired,
  errors: array,
  editable: bool,
};

EditableItem.defaultProps = {
  errors: [],
  editable: false,
};



// WEBPACK FOOTER //
// ./src/components/editable-list/listItem/component.js